const profileSettings = {
  loadFailed: "Failed to load profile",
  loadingProfile: "Loading profile...",
  title: "Profile & Settings",
  profileInfo: {
    heading: "Profile Information",
    institution: "Institution",
    accountStatus: "Account Status",
    active: "Active",
    inactive: "Inactive",
    accountCreated: "Account Created",
  },
  roleBanner: {
    orgAdmin: {
      title: "👑 Organization Administrator",
      description: "You have full administrative privileges in this system",
    },
    pi: {
      title: "Role: Principal Investigator",
      description:
        "You have administrative privileges to manage projects and users",
    },
  },
  security: {
    heading: "Security Settings",
    changePassword: "Change Password",
    changePasswordHint: "Update your password to keep your account secure",
    changing: "Changing...",
    successMessage: "Password changed successfully!",
    currentPasswordLabel: "Current Password *",
    newPasswordLabel: "New Password *",
    confirmPasswordLabel: "Confirm New Password *",
    passwordRequirement: {
      minLength: "Must be at least {{minLength}} characters",
      uppercase: ", uppercase",
      lowercase: ", lowercase",
      digit: ", number",
      specialChar: ", special character",
    },
    twoFactorLabel: "Two-Factor Authentication Code *",
    twoFactorPlaceholder: "000000",
    twoFactorHint: "Enter the 6-digit code from your authenticator app",
  },
  errors: {
    policyNotLoaded: "Password policy not loaded. Please try again.",
    passwordMismatch: "New passwords do not match",
    samePassword: "New password must be different from current password",
    twoFactorRequired: "Please enter your 6-digit 2FA code",
    changeFailed: "Failed to change password",
  },
};

export default profileSettings;
